// Translate Shopify sorting options for Arabic
(function() {
  const translations = {
    'Best selling': 'الأفضل مبيعاً',
    'Featured': 'مميز',
    'Alphabetically, A-Z': 'أبجدياً، أ-ي',
    'Alphabetically, Z-A': 'أبجدياً، ي-أ',
    'Price, low to high': 'السعر، من الأدنى للأعلى',
    'Price, high to low': 'السعر، من الأعلى للأدنى',
    'Date, old to new': 'التاريخ، من الأقدم للأحدث',
    'Date, new to old': 'التاريخ، من الأحدث للأقدم'
  };

  function translateSortOptions() {
    // Check if page is in Arabic (RTL)
    if (document.documentElement.dir !== 'rtl' && document.documentElement.lang !== 'ar') {
      return;
    }

    // Translate desktop sorting options
    const desktopOptions = document.querySelectorAll('#ProductsSortList .disclosure__link');
    desktopOptions.forEach(option => {
      const originalText = option.textContent.trim();
      if (translations[originalText]) {
        option.textContent = translations[originalText];
        option.setAttribute('data-name', translations[originalText]);
      }
    });

    // Translate the selected sort button
    const sortButton = document.querySelector('.sort-selector');
    if (sortButton) {
      const originalText = sortButton.textContent.trim();
      if (translations[originalText]) {
        sortButton.textContent = translations[originalText];
      }
    }

    // Translate mobile sorting options
    const mobileOptions = document.querySelectorAll('#SortBy-mobile option, #SortBy option');
    mobileOptions.forEach(option => {
      const originalText = option.textContent.trim();
      if (translations[originalText]) {
        option.textContent = translations[originalText];
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateSortOptions);
  } else {
    translateSortOptions();
  }

  // Also run when facets are updated (AJAX filtering)
  document.addEventListener('facet:updated', translateSortOptions);

  // Run after a short delay to catch dynamically loaded content
  setTimeout(translateSortOptions, 500);
})();
